import type {
  IAgentCommissionsPage,
  IAgentCommissionsQuery,
  IAgentCommissionsSummary,
} from '@share/common-types';
import { axiosInstance, getHeaders } from '@share/utils';
import { Urls } from '@share/constants';

// Always the logged agent's own commissions: the backend scopes by the token, never by a parameter.
export const getAgentCommissionsSummaryAsync = () =>
  axiosInstance.get<IAgentCommissionsSummary>(`${Urls.AgentCommissions}/Summary`, {
    ...getHeaders(false),
  });

export const getAgentCommissionsAsync = (query: IAgentCommissionsQuery) =>
  axiosInstance.get<IAgentCommissionsPage>(Urls.AgentCommissions, {
    ...getHeaders(false),
    params: query,
  });

